// extracted by mini-css-extract-plugin
module.exports = {"ratingCount":"RatingCount_ratingCount__gTN24"};